import { useEffect, useMemo, useRef, useState } from "react"

import { debounce } from 'lodash'
import { Textarea } from "twyne-new.ui"

import { useCraftProp } from "../utils"
import { html2js, js2html } from "../utils/ContentEditable"

const DEBOUNCE_DELAY = 300

export default function TextContentProperty() {
  const { value, setValue } = useCraftProp('content')
  const [localValue, setLocalValue] = useState(() => html2js(value))
  const [focus, setFocus] = useState(false)
  const setValueRef = useRef(setValue)

  useEffect(() => {
    setValueRef.current = setValue
  }, [setValue])

  const debouncedSetValue = useMemo(() => debounce(val => setValueRef.current(val), DEBOUNCE_DELAY), [])

  useEffect(() => () => debouncedSetValue.cancel(), [debouncedSetValue])

  useEffect(() => {
    if (!focus) {
      setLocalValue(html2js(value))
    }
  }, [value, focus])

  return <Textarea
    variant='accent'
    value={localValue}
    onFocus={() => setFocus(true)}
    onBlur={() => setFocus(false)}
    onChange={e => {
      setLocalValue(e.target.value)
      debouncedSetValue(js2html(e.target.value))
    }}
  />
}
